import React from 'react';
import { Link } from 'react-router-dom';
import './MarketBreadcrumb.scss';
import { NextArrow } from '../../assets/icons';

const MarketBreadcrumb = (props) => {
  const { filterApply, propertyListWebData } = props
  return (
    <div className={(!filterApply && propertyListWebData?.data?.count <= 0) ? 'breadcrumb mb-30' : 'breadcrumb'}>
      <div className='container-fluid'>
        <div className='breadcrumb__inner'>
          <div className='breadcrumb__header'>
            <p>
              {props.title} <span className='ml-4'>/</span>
            </p>
            <h4>{props.market}</h4>
          </div>
          {props.link && (
            <div className='breadcrumb__secondary mobile-hide'>
              <Link to={props.link}>
                {props.linkText} <NextArrow verticalAlign='0px' color='#fff' />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarketBreadcrumb;
